export const IS_HANDLE_CALLBACK_QUERY_PARAM = 'isHandleCallback';
export const SOCIAL_PLATFORM_QUERY_PARAM = 'socialPlatform';
